import React from 'react'
import { Select, MenuItem } from '@material-ui/core'
import withTranslation from '../hocs/withTranslation'

const VenueTypeFilter = ({ value = '', onChange, t }) => {
  return (
    <Select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      displayEmpty
      className='white-background'
      fullWidth
    >
      <MenuItem value=''>{t('conversation.allConversations')}</MenuItem>
      <MenuItem value='virtual'>{t('conversation.virtual')}</MenuItem>
      <MenuItem value='in_person'>{t('conversation.inPerson')}</MenuItem>
    </Select>
  )
}

export default withTranslation(VenueTypeFilter)
